var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skills"},[_c('h1',{staticClass:"divided"},[_vm._v("Skills")]),_c('skill-search',{attrs:{"initialQuery":_vm.initialQuery},on:{"query":_vm.onSearchQuery}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }